/**
 * Конфигурация i18n: реестр языков, namespaces, ключи хранения.
 *
 * Здесь единственное место, где перечислены поддерживаемые языки.
 * Добавление языка = добавить запись в SUPPORTED_LANGUAGES и папку locales/<code>.
 */

export const SUPPORTED_LANGUAGES = [
    { code: "ru", label: "Русский", short: "RU", dir: "ltr" },
    { code: "en", label: "English", short: "EN", dir: "ltr" },
    { code: "ar", label: "العربية", short: "AR", dir: "rtl" },
];

/** Язык по умолчанию (используется, если ничего не выбрано). */
export const DEFAULT_LANGUAGE = "ru";

/** Язык-подстраховка, если в выбранной локали нет ключа. */
export const FALLBACK_LANGUAGE = "ru";

/** Namespaces (файлы переводов). Ключ namespace = имя JSON-файла. */
export const NAMESPACES = [
    "common",
    "menu",
    "layout",
    "ui",
    "chat",
    "auth",
    "dashboard",
    "schedule",
    "staff",
    "warehouse",
    "products",
    "contacts",
    "knowledge_base",
    "settings",
    "finance",
    "instructions",
    "templates",
    "patients",
    "patient",
];

/** Namespace по умолчанию (common.*). */
export const DEFAULT_NAMESPACE = "common";

/** Ключ в localStorage для выбранного языка. */
export const LANGUAGE_STORAGE_KEY = "mis.language";

export const SUPPORTED_LANGUAGE_CODES = SUPPORTED_LANGUAGES.map((item) => item.code);

/**
 * Приводит любой код языка ("en-US", "AR", undefined) к поддерживаемому
 * базовому коду ("en", "ar", ...). Неизвестное -> DEFAULT_LANGUAGE.
 */
export function normalizeLanguage(lng) {
    const base = String(lng || "")
        .toLowerCase()
        .split("-")[0];
    return SUPPORTED_LANGUAGE_CODES.includes(base) ? base : DEFAULT_LANGUAGE;
}

/** Направление письма для языка: "ltr" или "rtl". */
export function getLanguageDir(lng) {
    const found = SUPPORTED_LANGUAGES.find((item) => item.code === normalizeLanguage(lng));
    return found?.dir || "ltr";
}

/** Человекочитаемое название языка. */
export function getLanguageLabel(lng) {
    const found = SUPPORTED_LANGUAGES.find((item) => item.code === normalizeLanguage(lng));
    return found?.label || DEFAULT_LANGUAGE;
}

/** BCP-47 локаль для Intl (даты, числа, валюта) по коду языка. */
export const LANGUAGE_LOCALES = {
    ru: "ru-RU",
    en: "en-US",
    ar: "ar-AE",
};

/** BCP-47 локаль для текущего языка (fallback — локаль языка по умолчанию). */
export function getLocale(lng) {
    const code = normalizeLanguage(lng);
    return LANGUAGE_LOCALES[code] || LANGUAGE_LOCALES[DEFAULT_LANGUAGE];
}
